/**
 * Products Service Types
 *
 * Type definitions for product tracking API operations.
 */

/**
 * Error thrown by product API operations
 */
export class ProductApiError extends Error {
  constructor(
    message: string,
    public readonly statusCode: number
  ) {
    super(message);
    this.name = 'ProductApiError';
  }
}

/**
 * Result from adding products
 */
export interface AddProductsResult {
  success: boolean;
  error?: string;
  added?: number;
}

/**
 * Result from removing products
 */
export interface RemoveProductsResult {
  success: boolean;
  error?: string;
  removed?: number;
}

/**
 * Threshold settings for products
 */
export interface ProductThresholds {
  urgentDays: number;
  warningDays: number;
}

/**
 * Parameters for adding products
 */
export interface AddProductsParams {
  productIds: string[];
  /** Threshold settings to apply to all added products */
  thresholds?: ProductThresholds;
}

/**
 * Parameters for removing products
 */
export interface RemoveProductsParams {
  variantIds: string[];
}
